"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAttributeValues = exports.getFirstAttributeValue = void 0;
const getFirstAttributeValue = (attributes, attributeName) => {
    const attribute = attributes && attributes[attributeName];
    if (!attribute || !attribute.values) {
        return;
    }
    if (attribute.multiSelect) {
        return attribute.values.length > 0 ? attribute.values[0] : undefined;
    }
    return attribute.values;
};
exports.getFirstAttributeValue = getFirstAttributeValue;
const getAttributeValues = (attributes, attributeName) => {
    const attribute = attributes && attributes[attributeName];
    if (!attribute || !attribute.values) {
        return [];
    }
    if (attribute.multiSelect) {
        return attribute.values;
    }
    return [attribute.values];
};
exports.getAttributeValues = getAttributeValues;
